<template>
  <div class="historycomment-list">
    <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
      <FormItem>
        <Input v-model="formItem.key" placeholder="输入事件标题" style="width:200px"></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="renderTable('formItem')">筛选</Button>
      </FormItem>
    </Form>
    <Table border :columns="columns" ref="selection" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "historycomment-list",
  data() {
    return {
      title: "",
      dataloading: true,
      formItem: {},
      pages: {
        current: 1,
        total: 0,
        size: 20
      },
      columns: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "事件标题",
          minWidth: 300,
          key: "title"
        },
        {
          title: "内容",
          minWidth: 300,
          key: "comment"
        },
        {
          title: "用户名",
          minWidth: 200,
          key: "username"
        },
        {
          title: "发布时间",
          minWidth: 200,
          key: "created_at"
        },
        {
          title: "状态",
          width: 150,
          key: "status",
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == "1" ? "禁用" : "正常")
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 330,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "0" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 1);
                    }
                  }
                },
                "正常"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "1" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id, 0);
                    }
                  }
                },
                "禁用"
              )
            ]);
          }
        }
      ],
      tablelist: []
    };
  },
  components: {},
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      var self = this;
      var params = { page: this.pages.current, size: this.pages.size };
      this.$api.history.commentlist(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    changePage() {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    review: function(id, index) {
      this.$api.history.commentstatus({ id: id, status: index }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.renderTable();
        }
      });
    },
    // 筛选
    renderTable: function(name) {
      var self = this;
      var ps = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key
      };
      this.$api.history.commentlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
};
</script>
